import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IconImage } from '@prisjakt/ui/icon/image';
import { IconPlayCircleOutlined } from '@prisjakt/ui/icon/play-circle-outlined';

import { ProductHeaderProductOfTheYearAwardBadge } from 'src/components/product-of-the-year/badges';
import { useIsProductOfTheYear } from 'src/components/product-of-the-year/hooks';
import { useProductContext } from '../product-context';
import ProductMediaLightbox from '../product-media-lightbox';
import MediaCounter from './media-counter';

import { productMediaOpen } from '../../actions/media';

import { trackProductMediaOpened } from './tracking';

import type { Media } from './types';

import { StyledCounters, StyledFirstImage, StyledProductMedia } from './styles';

type Props = {
  category?: {
    logo?: string | null;
  } | null;
  className?: string;
  media: Media;
  name: string;
};

export const ProductMedia = (props: Props) => {
  const { category, className, media, name } = props;

  const [show, setShow] = useState<boolean>(false);

  const dispatch = useDispatch();

  const hasLightboxContent = () => {
    return Boolean(media.large?.length || media.videos?.length);
  };

  const open = () => {
    if (!hasLightboxContent()) {
      return;
    }

    trackProductMediaOpened();

    setShow(true);
    dispatch(productMediaOpen());
  };

  const close = () => setShow(false);

  const { product } = useProductContext();
  const productOfTheYearAward = useIsProductOfTheYear(product.id);

  return (
    <>
      {show && <ProductMediaLightbox media={media} close={close} />}
      <StyledProductMedia
        className={className}
        onClick={open}
        data-test="ProductMedia"
        data-test-has-lightbox-content={hasLightboxContent()}
        $isFallbackImage={!media.first}
        $more={Boolean(media && media.images)}
      >
        {productOfTheYearAward && (
          <ProductHeaderProductOfTheYearAwardBadge
            badgeUrl={productOfTheYearAward.awardLogo}
            awardName={productOfTheYearAward.awardName}
            year={productOfTheYearAward.year}
          />
        )}
        <StyledFirstImage>
          <img src={media.first || category?.logo || undefined} alt={name} />
        </StyledFirstImage>
        {(media.images || media.videos) && (
          <StyledCounters>
            <MediaCounter icon={IconImage} mediaList={media.images} />
            <MediaCounter
              icon={IconPlayCircleOutlined}
              mediaList={media.videos}
            />
          </StyledCounters>
        )}
      </StyledProductMedia>
    </>
  );
};
